import { render } from "./FooterpageCom.vue?vue&type=template&id=24b1b42a&scoped=true"
import script from "./FooterpageCom.vue?vue&type=script&lang=js"
export * from "./FooterpageCom.vue?vue&type=script&lang=js"

import "./FooterpageCom.vue?vue&type=style&index=0&id=24b1b42a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b1b42a"]])

export default __exports__